import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class FilterDataService {
   filterOperators: any = {
    "EQUAL TO": (x: any, value: any) => x == value,
    "NOT EQUAL TO": (x: any, value: any) => x != value,
    "GREATER THAN": (x: any, value: any) => x > value,
    // "BETWEEN": (x: any, value: any) =>  x != value,
    // "NOT EQUAL TO": (x: any, value: any) => x != value,
    // "NOT EQUAL TO": (x: any, value: any) => x != value,

  };

  filter(data: any[], criteria: FilterCriteria[]): any[] {

    // let filterResults: boolean[] = [];
    // for (const filter of criteria) {
    //     const value = filter.value;
    //     const filterFunction = this.filterOperators[filter.operator];
    //     filterResults = data.map((item) => filterFunction(item, filter.value));

    // }
    // return filterResults;

    // var test = data.filter(item => this.applyFilters(item, criteria, data));
    // return data.filter(item => this.applyFilters(item, criteria, data));
     return this.applyFilters(criteria, data)
  }

  // private applyFilters(item: any, criteria: FilterCriteria[]): boolean {
  //   return criteria.every(filter => {
  //     const value = item[filter.field];

  //     switch (filter.operator) {
  //       case 'EQUAL TO':
  //         return value == filter.value;
  //       case 'NOT EQUAL TO':
  //         return value != filter.value;
  //       case 'GREATER THAN':
  //         return value > filter.value;
  //       case 'BETWEEN':
  //         const [min, max] = filter.value;
  //         return value >= min && value <= max;
  //       case 'LIKE':
  //         return value && value.toString().includes(filter.value);
  //       case 'NOT LIKE':
  //         return value && !value.toString().includes(filter.value);
  //       case 'IN':
  //         return filter.value.includes(value);
  //       case 'NOT IN':
  //         return !filter.value.includes(value);
  //       default:
  //         return true;
  //     }
  //   });
  // }
  // private applyFilters(item: any, criteria: FilterCriteria[]): boolean {

  //   const initialResult = criteria[0].logicalOperator === 'AND';
  //   return criteria.reduce((result, filter) => {
  //     const value = item[filter.field];

  //     switch (filter.operator) {
  //       case 'EQUAL TO':
  //         return filter.logicalOperator === 'AND' ? result && value == filter.value : result || value == filter.value;
  //       case 'NOT EQUAL TO':
  //         return filter.logicalOperator === 'AND' ? result && value != filter.value : result || value != filter.value;
  //       case 'GREATER THAN':
  //         return filter.logicalOperator === 'AND' ? result && value > filter.value : result || value > filter.value;
  //       case 'BETWEEN':
  //         const [min, max] = filter.value;
  //         const betweenResult = value >= min && value <= max;
  //         return filter.logicalOperator === 'AND' ? result && betweenResult : result || betweenResult;
  //       case 'LIKE':
  //         return filter.logicalOperator === 'AND' ? result && value && value.toString().includes(filter.value) : result || value.includes(filter.value);
  //       case 'NOT LIKE':
  //         return filter.logicalOperator === 'AND' ? result && value && !value.toString().includes(filter.value) : result || !value.includes(filter.value);
  //       case 'IN':
  //         return filter.logicalOperator === 'AND' ? result && filter.value.includes(value) : result || filter.value.includes(value);
  //       case 'NOT IN':
  //         return filter.logicalOperator === 'AND' ? result && !filter.value.includes(value) : result || !filter.value.includes(value);
  //       default:
  //         return true;
  //     }
  //   }, initialResult);
  // }

  conditions: any[] = [];
  // private applyFilters(item: any, criteria: FilterCriteria[], dataToFilter: any): boolean {



  //    criteria.reduce((result: boolean, filter) => {
  //     const value = item[filter.field];
  //     let filterResult = false;

  //     switch (filter.operator) {
  //       case 'EQUAL TO':
  //         filterResult = value == filter.value;

  //         break;
  //       case 'NOT EQUAL TO':
  //         filterResult = value != filter.value;
  //         break;
  //       case 'GREATER THAN':
  //         filterResult = value > filter.value;
  //         break;
  //       case 'BETWEEN':
  //         const [min, max] = filter.value;
  //         filterResult = value >= min && value <= max;
  //         break;
  //       case 'LIKE':
  //         filterResult = value && value.toString().includes(filter.value);
  //         break;
  //       case 'NOT LIKE':
  //         filterResult = value && !value.toString().includes(filter.value);
  //         break;
  //       case 'IN':
  //         filterResult = filter.value.includes(value);
  //         break;
  //       case 'NOT IN':
  //         filterResult = !filter.value.includes(value);
  //         break;
  //       default:
  //         filterResult = true;
  //         break;
  //     }

  //       this.conditions.push(item[filter.field] == filter.value);
  //     if (filter.logicalOperator === 'AND') {
  //       result = result && filterResult;
  //     } else if (filter.logicalOperator === 'OR') {
  //       result = result || filterResult;
  //     }

  //     return result;
  //   }, true as true);
  //   this.createFilterFunction(this.conditions, dataToFilter);
  //   return false;
  // }

  private applyFilters(criteria: FilterCriteria[], dataToFilter: any) {

    const dynamicConditions: ((condition: any) => boolean)[] = this.FillDynamicConditions(criteria);
    var FirstCondition : ((condition: any) => boolean)[] = [];
    FirstCondition.push(dynamicConditions[0]);
    var SecondCondition : ((condition: any) => boolean)[] = [];
    SecondCondition.push(dynamicConditions[1])
    var ThirdCondition : ((condition: any) => boolean)[] = [];
    ThirdCondition.push(dynamicConditions[2])
    if(criteria.length == 1)
    {
      dataToFilter = dataToFilter.filter((item: any) => FirstCondition.every((condition) =>  condition(item)));
    }
    if(criteria.length == 2)
    {
      if(criteria[0].logicalOperator == "AND")
      dataToFilter = dataToFilter.filter((item: any) => FirstCondition.every((condition) => condition(item)) && SecondCondition.every((condition) => condition(item)) );

      if(criteria[0].logicalOperator == "OR")
      dataToFilter = dataToFilter.filter((item: any) => FirstCondition.some((condition) => condition(item)) || SecondCondition.some((condition) => condition(item)) );

    }
    if(criteria.length == 3)
    {
      if(criteria[0].logicalOperator == "AND" && criteria[1].logicalOperator == "AND")
      dataToFilter = dataToFilter.filter((item: any) => FirstCondition.every((condition) => condition(item)) && SecondCondition.every((condition) => condition(item)) && ThirdCondition.every((condition) => condition(item)));

      if(criteria[0].logicalOperator == "AND" && criteria[1].logicalOperator == "OR")
      {
        dataToFilter = dataToFilter.filter((item: any) => FirstCondition.every((condition) => condition(item)));
      dataToFilter = dataToFilter.filter((item: any) =>  SecondCondition.some((condition) => condition(item))
       || ThirdCondition.some((condition) => condition(item)));
      }


      if(criteria[0].logicalOperator == "OR" && criteria[1].logicalOperator == "AND")
      {
        dataToFilter = dataToFilter.filter((item: any) => ThirdCondition.every((condition) => condition(item)));
      dataToFilter = dataToFilter.filter((item: any) =>  FirstCondition.some((condition) => condition(item))
       || SecondCondition.some((condition) => condition(item)));
      }


      if(criteria[0].logicalOperator == "OR" && criteria[1].logicalOperator == "OR")
      dataToFilter = dataToFilter.filter((item: any) => FirstCondition.some((condition) => condition(item)) || SecondCondition.some((condition) => condition(item)) || ThirdCondition.some((condition) => condition(item)));

    }
    return dataToFilter;
  }


  FillDynamicConditions(criteria: FilterCriteria[]): ((condition: any) => boolean)[]
  {
    const dynamicFields: string[] = [];
    const dynamicConditions: ((condition: any) => boolean)[] = [];
    criteria.forEach(element => {
      dynamicFields.push(element.field);
    });
    dynamicFields.forEach((field, index) => {
      const dynamicValue = criteria[index].value
      switch (criteria[index].operator) {
        case 'EQUAL TO':
          dynamicConditions.push((item) => item[field] && item[field].toString() == dynamicValue);
          break;
        case 'NOT EQUAL TO':
          dynamicConditions.push((item) => item[field] && item[field].toString() != dynamicValue);
          break;
        case 'GREATER THAN':
          dynamicConditions.push((item) => item[field] && item[field] > dynamicValue);
          break;
        case 'BETWEEN':
          const [min, max] = dynamicValue;
          dynamicConditions.push((item) => item[field] >= min && item[field] <= max);
          break;
        case 'LIKE':
          dynamicConditions.push((item) => item[field] && item[field].toString().includes(dynamicValue));
          break;
        case 'NOT LIKE':
          dynamicConditions.push((item) => item[field] && !item[field].toString().includes(dynamicValue));
          break;
        case 'IN':
          dynamicConditions.push((item) => item[field] && dynamicValue.includes(item[field].toString()));
          break;
        case 'NOT IN':
          dynamicConditions.push((item) => item[field] && !dynamicValue.includes(item[field].toString()));
          break;
        default:
         // filterResult = true;
          break;
      }
    });


    return dynamicConditions;
  }
   createFilterFunction(
    conditions: ((item: any) => boolean)[]
  , data: any): (item: any[]) => any[] {
    return function (item: any[]): any[] {
      return data.filter((item: any) => conditions.every((condition) => condition(item)));
    };
  }
}



export class FilterCriteria {
  field: string;
  operator: string;
  value: any;
  logicalOperator: string
}
